define("settings/components/plan-image", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if @shouldShowImage}}
    {{#if (eq @planType "starter")}}
      <img
        src="/assets/images/img--plan--starter.png"
        class="o--media tAC--plan__img"
      >
    {{else if (eq @planType "premium")}}
      <img
        src="/assets/images/img--plan--premium.png"
        class="o--media tAC--plan__img"
      >
    {{else if (eq @planType "plus")}}
      <img
        src="/assets/images/img--plan--plus.png"
        class="o--media tAC--plan__img"
      >
    {{else if (eq @planType "free")}}
      <img
        src="/assets/images/img--plan--free.png"
        class="o--media tAC--plan__img"
      >
    {{else if (eq @planType "brand")}}
      <img
        src="/assets/images/img--plan--brand.png"
        class="o--media tAC--plan__img"
      >
    {{else}}
      <img
        src="/assets/images/img--plan--free.png"
        class="o--media tAC--plan__img"
      >
    {{/if}}
  {{/if}}
  */
  {
    "id": "dINky703",
    "block": "[[[41,[30,1],[[[41,[28,[37,1],[[30,2],\"starter\"],null],[[[1,\"    \"],[10,\"img\"],[14,\"src\",\"/assets/images/img--plan--starter.png\"],[14,0,\"o--media tAC--plan__img\"],[12],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,1],[[30,2],\"premium\"],null],[[[1,\"    \"],[10,\"img\"],[14,\"src\",\"/assets/images/img--plan--premium.png\"],[14,0,\"o--media tAC--plan__img\"],[12],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,1],[[30,2],\"plus\"],null],[[[1,\"    \"],[10,\"img\"],[14,\"src\",\"/assets/images/img--plan--plus.png\"],[14,0,\"o--media tAC--plan__img\"],[12],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,1],[[30,2],\"free\"],null],[[[1,\"    \"],[10,\"img\"],[14,\"src\",\"/assets/images/img--plan--free.png\"],[14,0,\"o--media tAC--plan__img\"],[12],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,1],[[30,2],\"brand\"],null],[[[1,\"    \"],[10,\"img\"],[14,\"src\",\"/assets/images/img--plan--brand.png\"],[14,0,\"o--media tAC--plan__img\"],[12],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,\"img\"],[14,\"src\",\"/assets/images/img--plan--free.png\"],[14,0,\"o--media tAC--plan__img\"],[12],[13],[1,\"\\n  \"]],[]]]],[]]]],[]]]],[]]]],[]]]],[]],null]],[\"@shouldShowImage\",\"@planType\"],false,[\"if\",\"eq\"]]",
    "moduleName": "settings/components/plan-image.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});